<template>
  <div class="items-master" @click="closeDrawer" style="margin-bottom: 0;">
    <div class="header-container">
      <div class="v-center space-between">
        <div class="title-section module-header">
        <div>
          <h1 class="module-name">Items</h1>
          <p class="subtext">Track all materials in production and their current workflow stages</p>
        </div>
        <div>
        <div class="actions-section">
          <div class="sort-section">
            <label for="">Sort By:</label>
            <select v-model="selectedSort" class="sort" name="" id="">
              <option value="1">Latest</option>
              <option value="2">Oldest</option>
              <!-- <option value="3">Sort: A to Z</option>
              <option value="4">Sort: Z to A</option> -->
            </select>
          </div>
          <button @click.stop="toggleDrawer" class="btn addfilter">
            <div v-if="getAppliedFilterNumber" class="addfilter-badge">{{ getAppliedFilterNumber }}</div>
            <div v-if="getAppliedFilterNumber" class="addfilter-ping"></div>
            Add Filter
          </button>
        </div>
        </div>
        </div>
      </div>
    </div>

<div class="items-master-action m flex">
  <div class="drawer" :class="drawer ? 'open' : 'close'" ref="drawer">
    <div class="filters relative" @click.stop>
      <div class="input-group m">
        <h5 class="filter-by">
          Filter by Name, Product Code, Company, Step Name
        </h5>
        <input
          :class="{
            selectedOne: filtersTemp.searchKeyWord,
          }"
          type="text"
          v-model="filtersTemp.searchKeyWord"
          placeholder="Filter by Name, Product Code, Company, Step Name"
        />
      </div>

      <h5 class="filter-by">Created Date:</h5>
      <div class="date-range-inputs">
        <div class="date-field">
          <label>From :</label>
          <input
            type="date"
            placeholder="mm/dd/yyyy"
            @change="updateCreatedDateFrom"
            :value="filtersTemp.createdDate.from"
            :class="{ selectedOne: filtersTemp.createdDate.from }"
          />
        </div>
        <div class="date-field">
          <label>To :</label>
          <input
            type="date"
            placeholder="mm/dd/yyyy"
            @change="updateCreatedDateTo"
            :value="filtersTemp.createdDate.to"
            :min="filtersTemp.createdDate.from"
            :class="{ selectedOne: filtersTemp.createdDate.to }"
          />
        </div>
      </div>
    </div>

    <div class="v-center mt-3 space-between button-box">
      <span class="v-center gap-1">
        <button class="btn btn-cancel" @click="cancelFilter">
          Cancel
        </button>
        <button class="btn" @click="clearAllData">Clear All</button>
      </span>
      <button class="btn" @click="applyFilter">Apply</button>
    </div>
  </div>
</div>

<div class="table-section">
    <copy-item-master-table
      @updateList="updateList"
      :itemMasterList="itemMasterData"
      @selectPage="selectPage"
      :pageNumber="pageNumber"
      :perPage="perPage"
      :totalCount="totalCount"
    />

    <!-- TODO: Uncomment when createItemMaster component is created
    <modal
      title="Create New Item"
      :open="createNew"
      @close="itemCreated"
    >
      <create-item-master
        v-if="createNew"
        :open="createNew"
        @created="itemCreated"
        @close="itemCreated"
      />
    </modal>
    -->
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import copyItemMasterTable from '@/components/materialMaster/copyItemMasterTable.vue'
import { GetJobOrderMaterialLinks } from '@/api'
import Loader from '@/plugins/loader'
// import Modal from '../../components/common/modal.vue'
// import CreateItemMaster from '../../components/itemMaster/createItemMaster.vue' // TODO: Create this component
// import singleSelectDropDown from '../../components/common/singleSelectDropDown.vue'
import { alert } from '@/plugins/notification'

export default {
  components: {
    // Modal,
    // CreateItemMaster, // TODO: Add this back when component is created
    // singleSelectDropDown,
    copyItemMasterTable
  },
  data: () => ({
    selectedSort: '1',
    totalCount: 0,
    pageNumber: 1,
    perPage: 20,
    itemMasterData: [],
    clear: false,
    searchKeyWord: '',
    createNew: false,
    drawer: false,
    createdDate: { from: '', to: '' },
    filtersTemp: {
      searchKeyWord: '',
      createdDate: { from: '', to: '' }
    }
  }),
  computed: {
    ...mapGetters(['user', 'getUserById', 'isOnProjectLevel', 'collaborator']),
    // ...mapGetters('items', ['getFilters']), // TODO: Create items store module
    getAppliedFilterNumber () {
      let filterNo = 0
      if (this.searchKeyWord) {
        filterNo++
      }
      if (this.createdDate?.from || this.createdDate?.to) {
        filterNo++
      }
      if (!filterNo) {
        return false
      }
      return String(filterNo)?.padStart(2, '0')
    }
  },
  methods: {
    // ...mapMutations('items', ['updateFilters']), // TODO: Create items store module
    clearAllData () {
      // this.updateFilters({}) // TODO: Uncomment when store is ready
      this.clear = true
      this.searchKeyWord = ''
      this.createdDate = { from: '', to: '' }
      this.resetTempFilters()
      this.fetchItemMasterData()
      setTimeout(() => {
        this.clear = false
      }, 1000)
    },
    updateCreatedDateFrom (event) {
      this.filtersTemp.createdDate.from = event.target.value
    },

    updateCreatedDateTo (event) {
      this.filtersTemp.createdDate.to = event.target.value
    },
    applyFilter () {
      const filtersTemp = JSON.parse(JSON.stringify(this.filtersTemp))
      this.searchKeyWord = filtersTemp.searchKeyWord
      this.createdDate = filtersTemp.createdDate
      this.fetchItemMasterData()
    },
    resetFiltersFromState () {
      // this.searchKeyWord = this.getFilters.searchKeyWord ?? ''
      // this.filtersTemp.searchKeyWord = this.getFilters.searchKeyWord ?? ''
      // TODO: Uncomment when store is ready
      this.searchKeyWord = ''
      this.filtersTemp.searchKeyWord = ''
    },
    selectPage (pageNumber) {
      this.pageNumber = pageNumber
      this.$router.push(`/item-master/${pageNumber}`)
    },
    async updateList () {
      await this.fetchItemMasterData(this.pageNumber, false)
    },
    itemCreated () {
      this.createNew = false
      this.fetchItemMasterData(1)
    },
    async fetchItemMasterData (number, updateFilters = true) {
      if (updateFilters) {
        // this.updateFilters({
        //   searchKeyWord: this.searchKeyWord
        // }) // TODO: Uncomment when store is ready
      }

      const searchId = this.$route?.params?.itemId
      if (searchId) {
        this.searchKeyWord = searchId
      }

      let pageNumber
      if (number) {
        pageNumber = number
      } else {
        pageNumber = this.$route?.params?.pageNumber ?? 1
      }
      this.pageNumber = JSON.parse(this.$route.params?.pageNumber ?? 1)
      const height = window.innerHeight
      this.perPage = Math.floor((height - 246 - 10) / 45)
      const filter = {
        jump: (pageNumber - 1) * this.perPage,
        perPage: this.perPage,
        searchKeyword: this.searchKeyWord
          ? `%${this.searchKeyWord}%`
          : undefined,
        createdDate: this.createdDate
      }

      const loader = new Loader('.items-master-table')
      loader.show()
      const self = this

      try {
        const jobOrderRes = await GetJobOrderMaterialLinks(filter, this.selectedSort, this.isOnProjectLevel)
        self.itemMasterData = jobOrderRes?.job_order_material_links.map(item => {
          const obj = {
            job_order_sequence: item.core_form?.default_sequence,
            company_name: item.core_form?.forms_company_list?.core_tenant?.company_name || '--',
            project_id: item.core_form.project_id ?? null,
            workflow_state: item.workflow_instance?.state_value?.name || '--',
            instance_id: item?.workflow_instance?.id,
            form_id: item?.form_id,
            material_id: item.material_id,
            product_code: item.workflow_instance?.core_material_master?.material_product_code?.product_code || '--',
            current_workflow_step: {
              name: item.workflow_instance?.transition_history[0]?.current_workflow_step?.name || '--',
              step_id: item.workflow_instance?.transition_history[0]?.current_workflow_step?.id
            },
            core_user_group_members: item?.workflow_instance?.current_instance_step?.workflow_step?.core_user_group?.core_user_group_members,
            step_id: item?.workflow_instance?.current_instance_step?.workflow_step?.id,
            created_on: item.workflow_instance?.created_on,
            template_id: item.core_form?.template_version?.template_id,
            next_transition: item?.workflow_instance?.current_instance_step?.workflow_step.next_transition,
            end_step: item?.workflow_instance?.current_instance_step?.workflow_step?.end_step,
            history_id: item?.workflow_instance?.transition_history[0]?.id,
            wfInstanceId: item.workflow_instance?.id,
            workflow_instance: item.workflow_instance,
            qc_parent_step_id: item?.workflow_instance?.current_instance_step?.workflow_step?.qc_parent_step_id,
            qc_form_status: item?.workflow_instance?.transition_history[0]?.qc_form?.status,
            editInstance: this.getInstanceEditPermission(item),
            bar_code_blob_key: item.bar_code_blob_key,
            step_attachments: item?.workflow_instance?.current_instance_step?.core_attachments,
            trigger_actions: item?.workflow_instance?.current_instance_step?.workflow_step?.trigger_actions[0],
            workflow_step_resources_associations: item?.workflow_instance?.current_instance_step?.workflow_step?.workflow_step_resources_associations || [],
            instance_step_resources: item?.workflow_instance?.current_instance_step?.instance_step_resources || []
          }
          for (const material of item.core_form?.forms_material_lists) {
            if (material.material_id === obj.material_id) {
              obj.material_name = material.core_material?.material_name || '--'
              obj.priority = material?.priority
              break
            }
          }
          return obj
        }) || []
        self.totalCount = jobOrderRes?.job_order_material_links_aggregate?.aggregate?.count || 0
        loader.hide()
      } catch (err) {
        loader.hide()
        console.log(err)
        alert('something went wrong')
      }
    },
    toggleDrawer (event) {
      if (!this.drawer) {
        this.openDrawer()
      } else {
        this.closeDrawer()
      }
    },
    openDrawer () {
      this.clear = false
      this.drawer = true
      this.$nextTick(() => {
        this.$refs.drawer.focus()
      })
    },
    closeDrawer () {
      this.drawer = false
      this.resetTempFilters()
    },
    resetTempFilters () {
      this.filtersTemp = JSON.parse(JSON.stringify({
        searchKeyWord: this.searchKeyWord,
        createdDate: this.createdDate || { from: '', to: '' }
      }))
      this.clear = true
    },
    cancelFilter () {
      this.closeDrawer()
      this.resetTempFilters()
    },
    keyPress (e) {
      if (!this.drawer) { return }
      if (e instanceof KeyboardEvent && e.code === 'Escape') {
        this.cancelFilter()
      } else if (e instanceof KeyboardEvent && e.code === 'Enter') {
        this.fetchItemMasterData()
      }
    },
    getInstanceEditPermission (workflowData) {
      if (this.user.tenantLevelRole === 'ADMIN' || this.user.projectLevelRole === 'ADMIN') {
        return true
      } else if (workflowData?.workflow_instance?.current_instance_step?.instance_step_assignees?.some(item => item.user_id === this.user.userId)) {
        return true
      } else if (workflowData?.workflow_instance?.current_instance_step?.workflow_step?.core_user_group?.core_user_group_members?.some(item => item.user_id === this.user.userId)) {
        return true
      } else {
        return false
      }
    }
  },
  mounted () {
    this.resetFiltersFromState()
    this.fetchItemMasterData()
  },
  created () {
    document.body.addEventListener('keydown', this.keyPress)
  },
  watch: {
    '$route.params.pageNumber' () {
      this.fetchItemMasterData()
    },
    selectedSort (value) {
      if (value === '0') return
      this.fetchItemMasterData()
    }
  },
  beforeDestroy () {
    document.body.removeEventListener('keydown', this.keyPress)
    // this.updateFilters({}) // TODO: Uncomment when store is ready
  }
}
</script>

<style lang="scss" scoped>
.sort {
  height: 2em;
  width: 10rem;
  margin: 0 10px 0 10px;
  font-size: var(--text-s);
  background-color: var(--brand-light-color);
  line-height: 1;
  border: 1px solid var(--brand-color);
  border-radius: 4px;
  padding: 4px 12px;
}

.subtext {
  font-size: var(--text-xs2);
  color: #666;
  margin: 2px 0 0 0;
  font-weight: 400;
}

.title-section {
  width: 100%;
  display: flex;
  justify-content: space-between;

}

.actions-section {
  display: flex;
  align-items: center;
  gap: 12px;
}

.sort-section {
  display: flex;
  align-items: center;
  gap: 6px;

  label {
    font-size: var(--text-xs2);
    color: #666;
    font-weight: 400;
  }
}

.table-section {
  // margin-top: 20px;
}

.items-master {
  padding-bottom: 0;
  // padding-top: 20px;
  .header-container {
    display: flex;
    flex-direction: column;
    gap: 5px;
    header {
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid var(--border);
    }
  }
  .filter-options {
    margin: 10px 0 15px 0;
    margin-left: auto;
    display: flex;
    align-items: center;
  }
  padding-bottom: 10px;
  margin-bottom: 50px;
}

.drawer {
  position: fixed;
  margin-top: 20px;
  background-color: #f8f4f0;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  padding: 20px;
  border-radius: 5px;
  max-width: 80%;
  width: 400px;
  overflow: auto;
  z-index: 1000;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s, visibility 0.3s;
}

.drawer.open {
  opacity: 1;
  visibility: visible;
}

.filter-by {
  margin-top: 15px;
  margin-bottom: 8px;
}

.selectedOne {
  background-color: var(--brand-light-color) !important;
}

.button-box {
  background-color: #f8f4f0;
  position: sticky;
  bottom: -20px;
  display: flex;
  align-items: center;
}

.addfilter {
  position: relative;
  overflow: visible;
  font-size: var(--text-xs2);
  padding: 6px 12px;
  height: auto;

  &-badge {
    position: absolute;
    top: 0;
    right: 8px;
    transform: translate(50%, -50%);
    border-radius: 50%;
    background-color: var(--brand-color-1);
    z-index: 2;
    padding: 2px;
    width: 14px;
    height: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 8px;
    color: white;
    font-weight: 500;
  }
  &-ping {
    animation: ping 1.5s ease-in-out infinite both;
    padding: 8px;
    background-color: black;
    border-radius: 50%;
    transform: translate(50%, -50%);
    position: absolute;
    top: 0;
    right: 8px;
    z-index: 1;
  }
}

@keyframes ping {
  0% {
    transform: translate(50%, -50%);
    padding: 5px;
    opacity: 1;
  }
  100% {
    transform: translate(50%, -50%);
    padding: 18px;
    opacity: 0;
  }
}
.date-range-inputs {
  display: flex;
  flex-direction: column;
  gap: 10px;

  .date-field {
    display: flex;
    flex-direction: column;

    label {
      font-size: var(--text-base);
      margin-bottom: 5px;
      color: #333;
      font-weight: normal;
    }

    input[type="date"] {
      width: 100%;
      padding: 8px 12px;
      border: 1px solid #ccc;
      border-radius: 4px;
      background-color: white;
      font-size: var(--text-base);

      &.selectedOne {
        background-color: var(--brand-light-color) !important;
        border-color: var(--brand-color);
      }

      &:focus {
        outline: none;
        border-color: var(--brand-color);
      }
    }
  }
}
</style>
